/**
 * Formats string as phone number.
 * Currently only handles US phone numbers, numbers longer than 10 or 11 digits are returned without any formatting.
 * @param phoneNumber
 * @returns string The formatted phone number, or the original input value if it is not a US phone number.
 */
export function phone(phoneNumber) {
    // make sure we're always working with a string, and remove any special characters/spaces.
    const number = String(phoneNumber).replace(/\D/g, '');
    // currently only support 10 or 11 digit numbers.
    if (number.length > 11 || number.length < 10) {
        return String(phoneNumber);
    }
    return number.length === 11
        ? `${number[0]}-${number.substring(1, 4)}-${number.substring(4, 7)}-${number.substring(7, 11)}`
        : `${number.substring(0, 3)}-${number.substring(3, 6)}-${number.substring(6, 10)}`;
}
